/* eslint-disable */
import { useState } from "react";
import { useAuth } from "../auth-guard/AuthContext";

const LoginAdminPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const success = await login(username, password);
      if (success) {
        // 로그인 성공 시 페이지 새로고침 (라우터가 자동으로 리다이렉트)
        window.location.reload();
      } else {
        setError("로그인에 실패했습니다. 사용자명과 비밀번호를 확인해주세요.");
      }
    } catch (err) {
      console.error("❌ 로그인 실패:", err);
      setError("로그인 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-admin">
      <form onSubmit={handleLogin} className="login-form">
        <div className="title">ADMIN PAGE</div>
        <label>
          <input
            placeholder="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </label>
        <br />
        <label>
          <input
            placeholder="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <br />
        <button className="submit-btn" type="submit" disabled={loading}>
          {loading ? "로그인 중..." : "Log in"}
        </button>

        <div className="error">{error}</div>
      </form>
    </div>
  );
};

export default LoginAdminPage;
